import { render, staticRenderFns } from "./ChoiceField.vue?vue&type=template&id=66bbe4f8&scoped=true&"
import script from "./ChoiceField.vue?vue&type=script&lang=js&"
export * from "./ChoiceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bbe4f8",
  null
  
)

export default component.exports